import React, {
  Component,
  useContext,
  useState,
  useEffect,
  Fragment
} from "react";

import { currencies } from '../../data/currencies'

import { Tooltip } from "@material-ui/core";

import { Link } from "react-router-dom";
import { ProductConsumer } from "../../context";
import styled, { css } from "styled-components";
import Paper from "@material-ui/core/Paper";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";

import IconAdd from "@material-ui/icons/AddBox";
import IconRem from "@material-ui/icons/IndeterminateCheckBox";

import Typography from "@material-ui/core/Typography";
import red from "@material-ui/core/colors/red";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import IconDelete from "@material-ui/icons/Delete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { ProductContext } from "../../context";
import Colorer from "color";

import { Button } from "../uikit-b2c/uikit-b2c";

const defTheme = {
  id: "magenta",
  name: "Magenta Dark",
  colorText: "#D6E0E7",
  colorAccent: "#FF005B",
  colorAccentText: "#F6FAFF",
  colorBg: "#011627",

  borderRadius: 8,
  backgroundUrl:
    "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",

  cardWidth: 240,
  cardPadding: 24,

  boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
  transitionTime: "0.3s",
  transitionEasing: "ease-in-out",
  transition: "all 0.3s ease-in-out",
  transitionStyle: "0.3s ease-in-out",
  fontFamily:
    '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
};

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  cardTitle: {},
  card: {
    // minWidth: '300px',
    // height: 300,
    // marginBottom: 4 * 8,
  },
  h1: {
    fontWeight: "bold",
    fontSize: "1.2em",
    marginBottom: 1 * 8,
    color: "var(--mainDark)"
  },
  p: {
    flexGrow: 1,
    color: "var(--mainDark)"
  },
  price: {
    flexGrow: 1,
    // paddingLeft: 1 * 8,
    fontWeight: "600",
    color: "var(--mainBlue)"
  },
  media: {
    marginTop: 1 * 8,
    height: 0,
    paddingTop: "56.25%", // 16:9
    backgroundSize: "contain"
    // backgroundSize: 'cover',
    // backgroundColor: 'var(--lightBlue)',
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  }
});

const Product = ({
  addToCart = () => {
    void 0;
  },
  id,
  product,
  order,
  cardType,
  initClass,
  image_url,
  title,
  currency = "USD",
  price,
  priceFull,
  discountPercent = null,
  description,
  is_favorite,
  in_cart,
  template,
  theme = defTheme,
  cardWidth = 300
}) => {
  const [state, setState] = React.useState({
    expanded: false,
    cardShown: false
  });


  currency = currencies[currency]['symbol'];


  const valueFromContext = useContext(ProductContext);

  const [favorited, setFavorited] = React.useState(is_favorite);

  const getImage = () => {
    if (cardType === "virtualItems" || cardType === "currency") {
      return image_url;
    } else {
      if (cardType === "subscriptions") {
        let imgs = [
          "https://res.cloudinary.com/maiik/image/upload/e_hue:-68/v1568958260/reward_01_zfoz16.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568958260/reward_01_zfoz16.png",
          "https://res.cloudinary.com/maiik/image/upload/e_hue:71/v1568958260/reward_01_zfoz16.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568958293/reward_04_sea7a3.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568958304/reward_06_neq7kq.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568968595/payment_evseev_silver_lzaac0.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568968595/payment_evseev_bronze_pqse5y.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568968595/payment_evseev_gold_cqdlw6.png"
        ];
        return imgs[order];
      } else {
        return "https://res.cloudinary.com/maiik/image/upload/v1568958260/reward_01_zfoz16.png";
      }
    }
  };

  useEffect(() => {
    if (is_favorite !== favorited) {
      setFavorited(is_favorite);
    }
  }, [is_favorite]);

  let [inCart, setInCart] = useState(0);

  useEffect(() => {
    if (in_cart !== inCart) {
      setInCart(in_cart);
    }
  }, [in_cart]);

  const handleExpandClick = () => {
    setState({
      ...state,
      expanded: !state.expanded
    });
  };

  const calcPrice = (prc, q) => {
    return prc * q;
  };

  const formatPrice = prc => {
    if (!prc) return 0;
    if (prc.toString().split(".").length === 1) return prc;
    return prc.toString().search(".") !== -1 ? parseFloat(prc).toFixed(2) : prc;
  };

  const handleCartClick = (doWhat = "add") => {
  //  console.log("id = ", id);
    valueFromContext.setViValue(id, oneProduct => {
      if (doWhat === "add")
        oneProduct.in_cart = oneProduct.in_cart ? oneProduct.in_cart + 1 : 1;
      if (doWhat === "rem")
        oneProduct.in_cart = oneProduct.in_cart ? oneProduct.in_cart - 1 : 1;
      if (doWhat === "del") oneProduct.in_cart = 0;
      return oneProduct;
    });
  };

  const handleFavClick = event => {
    valueFromContext.setViValue(id, oneProduct => {
    //  console.log("id = ", id);
      oneProduct.is_favorite = oneProduct.is_favorite === 1 ? 0 : 1;
      return oneProduct;
    });
  };

  let time = null;
  useEffect(() => {
    if (!state.cardShown) {
      time = setTimeout(() => {
        setState({
          ...state,
          cardShown: true
        });
      }, order * 50);
    } else {
      setState({
        ...state,
        cardShown: true
      });
    }
    return () => {
      clearTimeout(time);
    };
  }, []);

  // const { classes } = props;
  // const { sku, name, image_url, description, amount, currency } = props;

  if (valueFromContext && valueFromContext["virtualItems"]) {
    return (
      <CssCardAppear className={!state.cardShown ? initClass : ""}>
        <CssCard
          cardType={cardType}
          cardWidth={cardWidth}
          theme={theme}
          template={template}
          image={getImage()}
          className="card0"
        >
          <div className="item_container">
            <div className="item">
              <div className="item_inner">
                <CssImage
                  className="c_pic"
                  style={{backgroundImage:`url(${image_url})`,}}
                />
                <CssInfo
                  className="c_txt"
                  style={{

                  }}
                >

                  <div className="c-txt0">



                  {/* <div className="c-txt1">
                    <div className="c_txt1_name" data-good="name">
                      {title}
                    </div>
                  </div> */}

                    <CssCardH1 theme={theme}>
                      {title}
                    </CssCardH1>

                  <div className="c-txt2">
                    <CssDescEllipsis className="c-txt1-clamp c_txt1_desc" data-good="desc">
                      {description}
                    </CssDescEllipsis>
                  </div>


                  <div className="c_price_new">
                              <div
                                className="c_txt1_price_new"
                                data-good="price_new"
                                style={{
                                  color: theme['colorAccent']
                                }}
                              >
                                <div className="text-block-2">{currency}&thinsp;{formatPrice(price)}</div>
                              </div>
                            </div>

                            <div className="c_txt1_price old">
                              {formatPrice(priceFull)}
                              <div className="price_old_strike" style={{borderTopColor:theme['colorAccent']}}/></div>
                            </div>


              </CssInfo>
              </div>

              <div className="item_buts">

                <Buttons
                  className="ix_actbuts"
                  style={{

                  }}
                >
                  <div className="buts_main_buy">

                  <span style={{margin: '0 0.2em'}}>
                    <Button
                    style={{height: 36, fontSize: '1.1em'}}
                    theme={theme}>Buy now</Button>
                    </span>

                    {/* <span style={{margin: '0 0.2em'}}>
                    <Button
                    style={{height: 36, fontSize: '1.1em', padding:'0 0.6em'}}
                    appearance="ghost" theme={theme}>
                      <svg width={18} height={14} viewBox="0 0 18 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                      <g id="Canvas" transform="translate(2183 241)">
                      <g id="Cart">
                      <use xlinkHref="#path0_fill" transform="translate(-2183 -241)" fill="currentColor" />
                      </g>
                      </g>
                      <defs>
                      <path id="path0_fill" fillRule="evenodd" d="M 15.8943 1.86667L 15.0984 3.93654C 15.0879 3.96393 15.0759 3.99048 15.063 4.01614L 13.2 9.584C 13.0635 9.99178 12.6816 10.2667 12.2517 10.2667L 3.85327 10.2667C 3.42334 10.2667 3.0415 9.99178 2.90503 9.584L 0.947266 3.73334L 0.600098 3.73334C 0.268555 3.73334 0 3.46471 0 3.13333L 0 2.46667C 0 2.1353 0.268555 1.86667 0.600098 1.86667L 14.073 1.86667L 14.572 0.568527C 14.6255 0.429626 14.7114 0.312469 14.8181 0.222397C 14.9282 0.0867157 15.0959 0 15.2844 0L 17.4001 0C 17.7314 0 18 0.268631 18 0.600006L 18 1.26666C 18 1.59804 17.7314 1.86667 17.4001 1.86667L 15.8943 1.86667ZM 12.5881 3.73334L 3.51685 3.73334C 3.18115 3.73334 2.94092 4.05775 3.03857 4.37898L 4.04736 7.69131C 4.17554 8.1123 4.56372 8.40001 5.00391 8.40001L 11.1013 8.40001C 11.5413 8.40001 11.9297 8.1123 12.0579 7.69131L 13.0664 4.37898C 13.1643 4.05775 12.9241 3.73334 12.5881 3.73334ZM 2.84204 12.6C 2.84204 11.8268 3.46875 11.2 4.24194 11.2L 4.28418 11.2C 5.05737 11.2 5.68408 11.8268 5.68408 12.6C 5.68408 13.3732 5.05737 14 4.28418 14L 4.24194 14C 3.46875 14 2.84204 13.3732 2.84204 12.6ZM 10.4211 12.6C 10.4211 11.8268 11.0479 11.2 11.821 11.2L 11.8633 11.2C 12.6365 11.2 13.2632 11.8268 13.2632 12.6C 13.2632 13.3732 12.6365 14 11.8633 14L 11.821 14C 11.0479 14 10.4211 13.3732 10.4211 12.6Z" />
                      </defs>
                      </svg>
                    </Button>
                    </span> */}



                  </div>


                  <div className="buts_main_preorder hidden">
                    <div className="but but_main">
                      <div>Pre-Order</div>
                    </div>
                  </div>
                </Buttons>
              </div>

              {template === 'blurred' && <CssHoverBg
                theme={theme}
                className="c_bg_hover"
                // style={{
                //   transition: "transform 200ms ease 0s, opacity 200ms ease 0s",
                //   opacity: 0,
                //   transform:
                //     "translateX(0px) translateY(-100px) scaleX(0.4) scaleY(0.4)"
                // }}
              >
                <div className="c_bg_blur"
                  style={{backgroundImage:`url(${image_url})`,}}
                />
              </CssHoverBg>}



              <div
                className="c_bg_feat hidden"
                style={{
                  transition: "transform 200ms ease 0s, opacity 200ms ease 0s",
                  opacity: "0.5",
                  transform: "scale(1)"
                }}
              >
                <div
                  className="c_bg_blur"
                  data-good="pic_bg"
                  style={{
                    backgroundImage: `url(${image_url})`
                  }}
                />
              </div>
              <div className="but_fav" data-badge="fav">
                <div className="but_icon">
                  <img
                    src="./Xsolla Shop_files/5982720fd8d584000149c4ad_but_star.svg"
                    width={13}
                  />
                </div>
              </div>
            </div>
          </div>
        </CssCard>
      </CssCardAppear>
    );
  } else {
    return null;
  }
};

// Product.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

const CssCartQs = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const CssCartQ = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bolder;
  min-width: 44px;
  font-size: 1.2em;
`;

const CssCardAppear = styled.div`
  /* position: relative; */
  height: 100%;
  /* transition: all ${props => props.order + "s"} ease-in-out; */
  transition: transform 350ms ease-out, opacity 150ms ease-out;
  &.initialFlow1 {
    opacity: 0;
    transform: translateY(20px) scale(1);
  };
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      width: 100%;
    `};
`;

// const CssCard = styled(Card)`
// Карточка не корзина
// Карточка корзина


const CssCardBack = styled.i`



  ${({ cardType }) =>
    cardType !== "cart" &&
    css`
      /* overflow: hidden; */
      flex-direction: column;
      flex-shrink: 0;
      flex-grow: 1;
      flex-base: 50%;
      background: transparent;
      border-radius: ${({ theme }) => theme["borderRadius"]}}px;
      box-shadow: none;
      content: " ";
      opacity: 1;
      overflow: hidden;
    `};






    ${({ cardType, template }) =>
      cardType !== "cart" &&
      !template &&
      css`
         {
          box-shadow: ${({ theme }) => !!theme && theme["boxShadow"]};
          background-color: ${({ theme }) =>
            !!theme &&
            Colorer(theme["colorAccent"])
              .alpha(0.7)
              .string()};
        }
      `};

    ${({ cardType, template }) =>
      cardType !== "cart" &&
      template === "blurred" &&
      css`
         {
          background-image: url(${({ image }) => image});
          background-size: cover;
          filter: blur(20px);
          opacity: 0.4;
          box-shadow: ${({ theme }) => !!theme && theme["boxShadow"]};
          background-color: ${({ theme }) =>
            !!theme &&
            Colorer(theme["colorAccent"])
              .alpha(0.6)
              .string()};
        }
      `};


&::before {
  content: ' ';
  /* ${({ template, theme, image }) => {
    return (
      template === "blurred" &&
      css` */

      /* `
    );
  }} */
}


`;

const CssCardH1 = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bolder;
  padding-bottom: 0.2em;
`;

const CssDescEllipsis = styled.div`
  /* display: block;
  display: -webkit-box; */
  opacity: 0.8;
  width: 100%;
  font-size: 0.84em;
  margin: 0 auto;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ cardWidth }) =>
    cardWidth < 200 &&
    css`
      display: none;
    `};
`;

const CssCardContent = styled.div`
  min-height: 70px;
  width: 100%;
  overflow: hidden;
  flex-grow: 0;
  padding-bottom: 0 !important;
  margin-bottom: 12px;
  ${({ cardWidth }) =>
    cardWidth < 200 &&
    css`
      min-height: auto;
    `};
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      /* display: flex; */
      /* flex-direction: column; */
      /* flex-wrap: wrap; */
      align-items: flex-start;
      justify-content: center;
    `};
`;

const CssCardActions = styled.div`
  ${({ cardType }) =>
    cardType !== "cart" &&
    css`
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-top: 1px solid
        ${({ theme }) =>
          Colorer(theme["colorText"])
            .alpha(0.1)
            .string()};
      padding: 8px 0 0 0;
      /* margin: 0px 16px 0 16px; */
    `}
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      /* padding: 16px 0; */
      width: 160px;
      display: grid;
      grid-template-columns: auto;
      grid-row-gap: 8px;
      place-content: start start;
      @media (max-width: 767px) {
        display: flex;
        width: 100%;
      }
    `}
`;

const CssCardActionsBorder = styled.div`
  border-top: 1px solid var(--mainDark);
  width: 100%;
`;

const CssCardMedia = styled.div`
  display: block;
  /* height: 0; */
  /* margin-top: 8px; */
  /* min-height: 120px; */
  flex-grow: 1;
  /* padding-top: 56.25%; */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center 0;
  background-image: url(${({ image }) => image});
  min-width: 120px;
  height: ${({ cardWidth }) => cardWidth}px;
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      width: 120px;
      min-height: 120px;
      margin-right: 1em;
    `}
`;

const CssPrice = styled.div`
  flex-grow: 1;
  flex-basis: 100%;
  font-size: 1.2em;
  /* color: ${({ theme }) => theme["colorAccent"]}; */
  font-weight: 600;
  flex-basis: auto;
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    flex-basis: 100%;
  }

  @media (max-width: 479px) {
  }
`;


export default Product;









const CssCard = styled.div`
  height: 100%;
  width: 100%;
  color: ${({ theme }) => (theme ? theme["colorText"] : "white")};
  display: flex;
  position: relative;
  z-index: 1;

  ${({ cardType }) =>
    cardType !== "cart" &&
    css`
      /* overflow: hidden; */
      /* position: relative; */
      flex-direction: column;
      flex-shrink: 0;
      flex-grow: 1;
      flex-base: 50%;
      background: transparent;
      transition: box-shadow ${({ theme }) =>
        !!theme ? theme["transitionStyle"] : "250ms ease-in-out"};
      /* border-radius: ${({ theme }) => theme["borderRadius"]}px; */
      ${({ cardWidth }) =>
        cardWidth < 200 &&
        css`
          /* font-size: 0.8em; */
        `};
    `}

  & i {
    opacity: 0;
    transition: all 250ms ease-in-out;
    /* width: 100%;
    height: 100%; */
    position: absolute;
    top: -8px;
    bottom: -16px;
    left: -16px;
    right: -16px;
    z-index: -1;
    overflow: hidden;
    border-radius: ${({ theme }) => theme["borderRadius"]}px;
  }

  &:hover i {
    ${({ cardType, template }) =>
      cardType !== "cart" &&
      !template &&
      css`
         {
          opacity: 0.3;
        }
      `};

    ${({ cardType, template }) =>
      cardType !== "cart" &&
      template === "blurred" &&
      css`
         {
          opacity: 0.3;
        }
      `};
  }
`;






const CssHoverBg = styled.div`
  background-color: ${({theme}) => Colorer(theme.colorBg).blacken(0.3).desaturate(0.4).hex()}
  transition: transform 200ms ease 0s, opacity 200ms ease 0s;
  opacity: 0;
  border-radius: ${({theme})=> theme['borderRadius']}px;
  transform: translateX(0px) translateY(-100px) scaleX(0.8) scaleY(0.8);
  .card0:hover & {
    opacity: 1;
    transform: scale3d(1, 1, 1) translateX(0px) translateY(0px) scaleX(1) scaleY(1);
    z-index: 0;
  }
`;
const CssImage = styled.div`
  transition: transform 0.4s ease 0s, -webkit-transform 0.4s ease 0s, transform 200ms ease 0s, opacity 200ms ease 0s;
  transform: translateX(0px) translateY(0px) scaleX(1) scaleY(1);
  .card0:hover & {
    transform: translateX(0px) translateY(-4px) scaleX(1.1) scaleY(1.1);
  }
`;

const CssInfo = styled.div`
  transition: transform 200ms ease 0s, opacity 200ms ease 0s;
  opacity: 1;
  transform: translateX(0px) translateY(0px);
  .card0:hover & {
    transform: translateX(0px) translateY(8px);
  }
`;


const Buttons = styled.div`
  transition: transform 200ms ease 0s, opacity 200ms ease 0s;
  opacity: 0;
  transform: translateX(0px) translateY(0px);
  .card0:hover & {
    opacity: 1;
    transform: translateX(0px) translateY(10px);
  }
`;
